import Domain from "./models/Domain"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getDomainInfo = () => ObservableFromFetch<Domain>(`ClientDomain/GetDomainInfo?name=${window.location.hostname}`)
